
/************************************************/
/* Page Object                                   */
/************************************************/
(function ($) {
  var sm = window.sm = window.sm || {};

  if (typeof sm.portal === 'undefined') {
    $.extend(sm, { portal: {} });
  }
  if (typeof sm.portal.page === 'undefined') {
    $.extend(sm.portal, { page: {} });
  }
  if (typeof sm.portal.page.continuingEducation === 'undefined') {
    $.extend(sm.portal.page, { continuingEducation: {} });
  }

  function initPage () {
    // Create the View Model
    window.viewModel = new sm.portal.vm.continuingEducation.ContinuingEducationViewModel();

    loadTemplates();
  }

  function loadTemplates () {
    window.viewModel.AccountViewModel.IsUserLoggedIn(function () {

      window.viewModel.DataLoading(true);
      window.viewModel.BaseApiURL(_baseApiUri);
      window.viewModel.TemplatesURL(_uploadPath + '/templates/');
      // Load the Account Templates
      $.when(
        sm.portal.vm.custom.loadCustomTemplate(),
        sm.portal.utility.loadTemplate('ValidationFieldTemplate', 'validationFieldTemplate'),
        sm.portal.utility.loadTemplate('ApplicationTemplate', 'formTemplates'),
        sm.portal.utility.loadTemplate('ValidationFieldTemplate', 'validationTemplates'),
        // templates added to the page
          sm.portal.utility.loadTemplate('MailingAddressTemplate', 'addressFormTemplates'),
          sm.portal.utility.loadTemplate('MailingAddressTemplateNew', 'addressFormTemplatesNew'),
        sm.portal.utility.loadTemplate('AccountTemplate', 'accountTemplates'),
        sm.portal.utility.loadTemplate('PortalValidationMessagesTemplate', 'portalValidationMessagesTemplates'),
        sm.portal.utility.loadTemplate('PortalWarningMessagesTemplate', 'portalWarningMessagesTemplates'),

      ).done(function () {
        window.viewModel.LoadInitialData();
        window.viewModel.TemplatesLoaded(true);

        // Bind to Page Elements
        ko.applyBindings(window.viewModel);

        if (window.viewModel.AccountViewModel.IsLoggedIn()) {
          // Do we have a student?
          window.viewModel.CheckForActiveCESAR();

          // redirect to registration
          // window.location = '/?u4sm_page=registration';
        }
      });
    });
  }

  $.extend(true, sm.portal.page.continuingEducation, {
    initPage: initPage
  });
})(jQuery);

/// ************************************************/
/// * Event Hooks                                  */
/// ************************************************/
(function ($) {
  $(document).bind('afterSMInitPage', function () {
    sm.portal.page.continuingEducation.initPage();
  });
})(jQuery);
